import { reactive, ref } from 'vue'
import { isFunction } from 'lodash'

export function useModal(options = {}) {
  const visible = ref(false)
  const data = ref({})

  function open(val) {
    const { onOpen } = options
    visible.value = true
    if (val) data.value = structuredClone(val)
    if (isFunction(onOpen)) onOpen(val)
  }

  function close() {
    const { onClose } = options
    visible.value = false
    if (isFunction(onClose)) onClose()
    setTimeout(() => (data.value = {}), 300)
  }

  return reactive({
    visible,
    data,
    open,
    close,
  })
}
